'use client';

import React, { useState } from 'react';
import LayoutDefault from '../../layouts/LayoutDefault';
import { 
  SearchIcon, 
  ArrowLeftIcon, 
  FolderIcon, 
  LargeVideoIcon, 
  LargeImageIcon,   
  LargeAudioIcon, 
  Large3DIcon, 
  LargeDocumentIcon, 
  LargeFlipBookIcon 
} from '../../utils/icons';

// Mock data for demo
const mockAssetTypes = [
  { id: 1, name: 'photo' },
  { id: 2, name: 'video' },
  { id: 3, name: 'audio' },
  { id: 4, name: 'model' },
  { id: 5, name: 'document' }
];

const mockCategoriesData = {
  asset_type: { id: 2, name: "photo" },
  parent_category: null,
  requested_level: 0,
  parent_category_uuid: "",
  item_type: "categories" as const,
  total_items: 3,
  categories: [
    {
      uuid: "an-giang",
      description: "Tỉnh An Giang",
      parent_uuid: null,
      is_show: 1,
      index: 1,
      view_count: 0,
      display_mode: 0,
      created_by: null,
      created_at: "2025-09-16 11:35:19",
      updated_by: 1,
      updated_at: "2025-09-16 11:35:19",
      category_title: "An Giang"
    },
    {
      uuid: "can-tho",
      description: "Thành phố Cần Thơ",
      parent_uuid: null,
      is_show: 1,
      index: 2,
      view_count: 0,
      display_mode: 0,
      created_by: null,
      created_at: "2025-09-16 11:35:19",
      updated_by: 1,
      updated_at: "2025-09-16 11:35:19",
      category_title: "Cần Thơ"
    },
    {
      uuid: "dong-thap",
      description: "Tỉnh Đồng Tháp",
      parent_uuid: null,
      is_show: 1,
      index: 3,
      view_count: 0,
      display_mode: 0,
      created_by: null,
      created_at: "2025-09-16 11:35:19",
      updated_by: 1,
      updated_at: "2025-09-16 11:35:19",
      category_title: "Đồng Tháp"
    }
  ],
  assets: []
};

const mockAssetsData = {
  asset_type: { id: 2, name: "photo" },
  parent_category: {
    uuid: "di-tich-van-hoa-oc-eo",
    description: null,
    parent_uuid: "an-giang",
    is_show: 1,
    index: null,
    view_count: 0,
    display_mode: 0,
    created_by: null,
    created_at: null,
    updated_by: null,
    updated_at: "2025-09-16 11:35:19",
    category_title: "Di tích Văn hóa Óc Eo"
  },
  requested_level: 2,
  parent_category_uuid: "di-tich-van-hoa-oc-eo",
  item_type: "assets" as const,
  total_items: 5,
  categories: [],
  assets: [
    {
      uuid: "photo_68c8e945454a1",
      category_uuid: "di-tich-van-hoa-oc-eo",
      asset_type_id: 2,
      is_show: 1,
      index: null,
      view_count: 0,
      approve: 2,
      created_by: null,
      created_at: "2025-09-16 11:35:19",
      updated_by: 1,
      updated_at: "2025-09-24 10:10:46",
      asset_title: "Ảnh Di tích Óc Eo 01",
      asset_type_name: "photo",
      attributes: {
        title_other: {
          id: 156,
          description: null,
          title: "Tên gọi khác",
          values: "Di tích cổ Óc Eo"
        },
        thumbnail: {
          id: 20,
          description: "Ảnh đại diện",
          title: "Ảnh đại diện",
          values: "https://picsum.photos/200/150?random=1"
        }
      }
    },
    {
      uuid: "photo_68c8e94546d32",
      category_uuid: "di-tich-van-hoa-oc-eo",
      asset_type_id: 2,
      is_show: 1,
      index: null,
      view_count: 0,
      approve: 2,
      created_by: null,
      created_at: "2025-09-16 11:35:19",
      updated_by: 1,
      updated_at: "2025-09-24 10:10:46",
      asset_title: "Ảnh Di tích Óc Eo 02",
      asset_type_name: "photo",
      attributes: {
        title_other: {
          id: 156,
          description: null,
          title: "Tên gọi khác",
          values: "Khu khảo cổ Óc Eo"
        },
        thumbnail: {
          id: 20,
          description: "Ảnh đại diện",
          title: "Ảnh đại diện",
          values: "https://picsum.photos/200/150?random=2"
        }
      }
    },
    {
      uuid: "photo_68c8e945478a9",
      category_uuid: "di-tich-van-hoa-oc-eo",
      asset_type_id: 2,
      is_show: 0,
      index: null,
      view_count: 0,
      approve: 2,
      created_by: null,
      created_at: "2025-09-16 11:35:19",
      updated_by: 1,
      updated_at: "2025-09-24 10:10:46",
      asset_title: "Ảnh Di tích Óc Eo 03",
      asset_type_name: "photo",
      attributes: {
        title_other: {
          id: 156,
          description: null,
          title: "Tên gọi khác",
          values: "Hiện vật Óc Eo"
        },
        thumbnail: {
          id: 20,
          description: "Ảnh đại diện",
          title: "Ảnh đại diện",
          values: "https://picsum.photos/200/150?random=3"
        }
      }
    }
  ]
};

interface AssetManageDemoProps {
  onClose: () => void;
  isSidebarOpen: boolean;
}

export default function AssetManageDemo({ onClose, isSidebarOpen }: AssetManageDemoProps) {
  const [selectedAssetType, setSelectedAssetType] = useState(null);
  const [currentData, setCurrentData] = useState(null);
  const [navigationHistory, setNavigationHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // Handle asset type selection
  const handleAssetTypeSelect = (assetType) => {
    setSelectedAssetType(assetType);
    setNavigationHistory([]);
    setCurrentData(mockCategoriesData);
  };

  // Handle category double click
  const handleCategoryDoubleClick = (category) => {
    // Simulate drilling down to assets
    if (category.uuid === "an-giang") {
      const subCategoryData = {
        ...mockCategoriesData,
        requested_level: 1,
        parent_category: category,
        categories: [
          {
            uuid: "di-tich-van-hoa-oc-eo",
            description: "Di tích lịch sử văn hóa",
            parent_uuid: "an-giang",
            is_show: 1,
            index: 1,
            view_count: 0,
            display_mode: 0,
            created_by: null,
            created_at: "2025-09-16 11:35:19",
            updated_by: 1,
            updated_at: "2025-09-16 11:35:19",
            category_title: "Di tích Văn hóa Óc Eo"
          }
        ]
      };
      setCurrentData(subCategoryData);
      setNavigationHistory([{ level: 0, data: mockCategoriesData }]);
    } else if (category.uuid === "di-tich-van-hoa-oc-eo") {
      setCurrentData(mockAssetsData);
      setNavigationHistory(prev => [...prev, { level: 1, data: currentData }]);
    }
  };

  // Handle back navigation
  const handleBackNavigation = () => {
    if (navigationHistory.length > 0) {
      const newHistory = [...navigationHistory];
      const previousState = newHistory.pop();
      setCurrentData(previousState.data);
      setNavigationHistory(newHistory);
    }
  };

  // Generate breadcrumb path
  const getBreadcrumbPath = () => {
    const path = [selectedAssetType?.name || 'Loại Asset'];
    
    if (currentData?.parent_category) {
      path.push(currentData.parent_category.category_title);
    }
    
    return path;
  };

  // Get asset icon
  const getAssetIcon = (assetTypeName) => {
    switch (assetTypeName.toLowerCase()) {
      case 'video': return LargeVideoIcon;
      case 'image':
      case 'photo': return LargeImageIcon;
      case 'audio': return LargeAudioIcon;
      case 'model':
      case '3d': return Large3DIcon;
      case 'document': return LargeDocumentIcon;
      case 'flipbook': return LargeFlipBookIcon;
      default: return LargeDocumentIcon;
    }
  };

  // Filter function for search
  const filterItems = (items, searchTerm) => {
    if (!searchTerm.trim()) return items;
    
    return items.filter(item => {
      const title = item.category_title || item.asset_title || `Asset ${item.uuid}`;
      return title.toLowerCase().includes(searchTerm.toLowerCase());
    });
  };

  const filteredCategories = currentData?.categories 
    ? filterItems(currentData.categories, searchTerm)
    : [];

  const filteredAssets = currentData?.assets 
    ? filterItems(currentData.assets, searchTerm)
    : [];

  return (
    <LayoutDefault onClose={onClose} isSidebarOpen={isSidebarOpen}>
      <div className="h-screen overflow-hidden bg-[#F8F8F8] flex">
        {/* Left Sidebar - Asset Types */}
        <div className="w-80 bg-white border-r border-gray-200 flex flex-col">
          {/* Sidebar Header */}
          <div className="bg-[#ECECEC] px-4 py-6 border-b">
            <h2 className="text-lg font-bold uppercase text-black">
              LOẠI HIỆN VẬT (DEMO)
            </h2>
          </div>

          {/* Asset Types List */}
          <div className="flex-1 overflow-y-auto p-4">
            <div className="space-y-2">
              {mockAssetTypes.map((assetType) => (
                <button
                  key={assetType.id}
                  onClick={() => handleAssetTypeSelect(assetType)}
                  className={`w-full text-left p-3 rounded-lg transition-colors ${
                    selectedAssetType?.id === assetType.id
                      ? 'bg-blue-100 border border-blue-300 text-blue-800'
                      : 'bg-gray-50 hover:bg-gray-100 border border-transparent'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center">
                      {(() => {
                        const IconComponent = getAssetIcon(assetType.name);
                        return <IconComponent />;
                      })()}
                    </div>
                    <span className="font-medium capitalize">{assetType.name}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Right Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Main Header */}
          <div className="bg-[#ECECEC] px-6 py-8">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-8">
                <h1 className="text-[28px] font-bold uppercase text-black tracking-wide">
                  QUẢN LÝ HIỆN VẬT - DEMO
                </h1>
              </div>
            </div>
          </div>

          {/* Toolbar and Search */}
          {selectedAssetType && (
            <div className="bg-white border-b-2 border-[#ECECEC] px-6 py-5">
              <div className="flex items-center justify-between">
                {/* Search */}
                <div className="flex items-center gap-4 bg-white border border-[#E0E0E0] rounded-[10px] px-[27px] py-5 w-[480px] h-[60px]">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <SearchIcon />
                  </div>
                  <input
                    type="text"
                    placeholder="Tìm kiếm hiện vật (Demo)"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="flex-1 text-xl text-[#B0B0B0] placeholder-[#B0B0B0] bg-transparent outline-none"
                  />
                </div>

                {/* Navigation */}
                <div className="flex items-center gap-4">
                  <button
                    onClick={handleBackNavigation}
                    disabled={navigationHistory.length === 0}
                    className={`flex items-center gap-[10px] px-[10px] py-[10px] rounded-[10px] transition-colors ${
                      navigationHistory.length === 0
                        ? 'opacity-50 cursor-not-allowed'
                        : 'hover:bg-gray-50'
                    }`}
                  >
                    <div className="w-10 h-10 flex items-center justify-center">
                      <ArrowLeftIcon />
                    </div>
                    <span className="text-xl text-black font-normal">Quay lại</span>
                  </button>
                </div>
              </div>

              {/* Breadcrumb */}
              <div className="mt-4 flex items-center gap-2 text-sm text-gray-600">
                {getBreadcrumbPath().map((item, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <span className="mx-2">/</span>}
                    <span className={index === getBreadcrumbPath().length - 1 ? 'font-medium text-black' : ''}>
                      {item}
                    </span>
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}

          {/* Content Area */}
          <div className="flex-1 overflow-y-auto p-6">
            {!selectedAssetType ? (
              <div className="flex flex-col items-center justify-center h-full text-center">
                <div className="w-24 h-24 mb-6 opacity-20">
                  <FolderIcon />
                </div>
                <h3 className="text-xl font-medium text-gray-500 mb-2">
                  Chọn loại hiện vật
                </h3>
                <p className="text-base text-gray-400 max-w-md">
                  Chọn một loại hiện vật từ menu bên trái để xem demo dữ liệu.
                </p>
              </div>
            ) : currentData ? (
              <div className="grid grid-cols-3 gap-6">
                {/* Render Categories */}
                {filteredCategories.map((category) => (
                  <div
                    key={category.uuid}
                    onDoubleClick={() => handleCategoryDoubleClick(category)}
                    className="bg-white border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-md transition-all duration-200 cursor-pointer"
                  >
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 flex items-center justify-center bg-blue-50 rounded-lg">
                        <FolderIcon />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-lg font-medium text-black truncate">
                          {category.category_title}
                        </h3>
                        <p className="text-sm text-gray-500">
                          Category • Nhấp đúp để xem
                        </p>
                        {category.description && (
                          <p className="text-xs text-gray-400 mt-1 line-clamp-2">
                            {category.description}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                {/* Render Assets */}
                {filteredAssets.map((asset) => {
                  const IconComponent = getAssetIcon(asset.asset_type_name);
                  const thumbnailUrl = asset.attributes?.thumbnail?.values;
                  
                  return (
                    <div
                      key={asset.uuid}
                      className="bg-white border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-md transition-all duration-200 cursor-pointer"
                    >
                      <div className="flex items-center gap-4">
                        <div className="w-16 h-16 flex items-center justify-center bg-green-50 rounded-lg overflow-hidden">
                          {thumbnailUrl && (
                            <img 
                              src={thumbnailUrl} 
                              alt={asset.asset_title || 'Asset'}
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.style.display = 'none';
                                target.nextElementSibling?.classList.remove('hidden');
                              }}
                            />
                          )}
                          <div className={thumbnailUrl ? 'hidden' : ''}>
                            <IconComponent />
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="text-lg font-medium text-black truncate">
                            {asset.asset_title || `${asset.asset_type_name} ${asset.uuid.slice(-6)}`}
                          </h3>
                          <p className="text-sm text-gray-500 capitalize">
                            {asset.asset_type_name}
                          </p>
                          <div className="flex items-center gap-2 mt-1">
                            <span className={`inline-block w-2 h-2 rounded-full ${asset.is_show ? 'bg-green-500' : 'bg-gray-400'}`}></span>
                            <span className="text-xs text-gray-400">
                              {asset.is_show ? 'Hiển thị' : 'Ẩn'}
                            </span>
                          </div>
                        </div>
                      </div>
                      
                      {/* Asset attributes preview */}
                      {asset.attributes && (
                        <div className="mt-3 pt-3 border-t border-gray-100">
                          <div className="text-xs text-gray-500">
                            {Object.entries(asset.attributes)
                              .filter(([key]) => !['thumbnail', 'parent_display_id'].includes(key))
                              .slice(0, 1)
                              .map(([key, attr]: [string, any]) => (
                                <div key={key} className="truncate">
                                  <span className="font-medium">{attr.title}:</span> {attr.values}
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}

                {/* Empty state */}
                {filteredCategories.length === 0 && filteredAssets.length === 0 && (
                  <div className="col-span-3 flex flex-col items-center justify-center py-16 text-center">
                    <div className="w-24 h-24 mb-6 opacity-20">
                      <FolderIcon />
                    </div>
                    <h3 className="text-xl font-medium text-gray-500 mb-2">
                      {searchTerm ? 'Không tìm thấy kết quả' : 'Không có dữ liệu'}
                    </h3>
                    <p className="text-base text-gray-400 max-w-md">
                      {searchTerm 
                        ? `Không tìm thấy hiện vật nào khớp với "${searchTerm}"`
                        : 'Chưa có category hoặc asset nào trong mục này.'
                      }
                    </p>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </LayoutDefault>
  );
}
